import _Slider from "@material-ui/core/esm/Slider";
import _ButtonBase from "@material-ui/core/esm/ButtonBase";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useStyles } from "./VideoStyles";
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { formatSeconds } from "../../../helpers/dateManagement";
import { useImagesCarousel } from "../hooks/useImagesCarousel";
import { useMedia } from "../../../hooks/useMedia";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import VolumeMuteIcon from '@material-ui/icons/VolumeMute';

var _ref2 = /*#__PURE__*/_jsx(PlayArrowIcon, {});

var _ref3 = /*#__PURE__*/_jsx(PauseIcon, {});

var _ref4 = /*#__PURE__*/_jsx(VolumeMuteIcon, {});

var _ref5 = /*#__PURE__*/_jsx(VolumeUpIcon, {});

var _ref6 = /*#__PURE__*/_jsx(FullscreenIcon, {});

const Video = _ref => {
  let className = _ref.className,
      src = _ref.src;
  const classes = useStyles();
  const carousel = useImagesCarousel();
  const hideControlsTimeoutRef = useRef();
  const videoRef = useRef();

  const _useMedia = useMedia(videoRef),
        paused = _useMedia.paused,
        muted = _useMedia.muted,
        progress = _useMedia.progress,
        volume = _useMedia.volume,
        handlePlayClick = _useMedia.handlePlayClick,
        handleChangeProgress = _useMedia.handleChangeProgress,
        handleChangeVolume = _useMedia.handleChangeVolume;

  const _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        duration = _useState2[0],
        setDuration = _useState2[1];

  const _useState3 = useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        controlsVisible = _useState4[0],
        setControlsVisible = _useState4[1];

  const video = videoRef.current;
  useEffect(() => !carousel.visible && video.pause(), [carousel.visible]);

  const handleFullScreenClick = () => video.requestFullscreen();

  const handleShowControls = () => {
    setControlsVisible(true);
    hideControlsTimeoutRef.current && clearTimeout(hideControlsTimeoutRef.current);
    hideControlsTimeoutRef.current = setTimeout(() => {
      setControlsVisible(false);
      hideControlsTimeoutRef.current = null;
    }, 3000);
  };

  return _jsx("div", {
    onMouseMoveCapture: handleShowControls,
    onClick: event => event.stopPropagation(),
    className: "".concat(classes.container, " ").concat(className)
  }, void 0, React.createElement("video", {
    onLoadedData: event => setDuration(event.target.duration),
    onClick: handlePlayClick,
    ref: videoRef,
    className: classes.video
  }, _jsx("source", {
    src: src
  })), _jsx("div", {
    className: "".concat(classes.controls, " ").concat((controlsVisible || paused) && 'visible')
  }, void 0, _jsx("div", {
    className: classes.controlsRow
  }, void 0, _jsx(_ButtonBase, {
    className: classes.icon,
    disableRipple: true,
    onClick: handlePlayClick
  }, void 0, paused ? _ref2 : _ref3), _jsx(_ButtonBase, {
    className: "".concat(classes.icon, " volume"),
    disableRipple: true,
    onClick: () => handleChangeVolume(null, video.volume > 0 ? 0 : 100)
  }, void 0, muted ? _ref4 : _ref5), _jsx(_Slider, {
    className: classes.volumeSlider,
    value: volume,
    onChange: handleChangeVolume
  }), _jsx("div", {
    style: {
      flexGrow: 1
    }
  }), _jsx(_ButtonBase, {
    className: classes.icon,
    disableRipple: true,
    onClick: handleFullScreenClick
  }, void 0, _ref6)), _jsx("div", {
    className: classes.controlsRow
  }, void 0, duration && _jsx("div", {
    className: classes.duration
  }, void 0, formatSeconds(video.currentTime || duration)), _jsx("div", {
    onClick: handleChangeProgress,
    className: classes.progress
  }, void 0, _jsx("div", {
    style: {
      width: "".concat(progress, "%")
    }
  })))));
};

export { Video };